import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsComposant() {
  const descriptionList = [
    "Votre ordinateur souffre d'un écran fissuré, d'un clavier défectueux, d'un disque dur trop lent ou d'une RAM insuffisante ? Le remplacement de composants permet de redonner une seconde vie à votre appareil sans avoir à en acheter un neuf.",
    "Les composants remplaçables incluent : écran, clavier, pavé tactile, connecteur d'alimentation, RAM, disque dur (SSD ou HDD), batterie, ventilateurs et parfois le processeur (selon le modèle).",
  ];
  const deroulementList = [
    "1 Prise de rendez vous : Nous convenons d'un rendez vous à notre atelier.",
    "2 Commande de la pièce (si nécessaire): Si elle doit être commandée, deux options s'offrent à vous. Soit nous la commandons pour vous (des charges d'entreprises s'appliquent). Soit vous la commandez (nous vous conseillons si besoin) pour économiser sur le coût des pièces.",
    "3 Remplacement du composant : Une fois la pièce disponible, nous procèdons à son installation avec soin dans notre atelier.",
    "4 Tests et vérification : Nous nous assurons que tout fonctionne parfaitement avant de vous contacter pour la récupération de votre appareil.",
    "5 (Optionnel) Réinstallation du système ou transfert de données : Si souhaité, nous pouvons remettre votre système à neuf et transférer vos données.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="CHANGEMENT DE COMPOSANT"
        price="De 10€ à 30€ + prix de la pièce à remplacer"
        atelier={true}
        domicile={false}
        time="15min - 1h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Options supplémentaires : Réinstallation du système d’exploitation et/ou transfert des données disponibles. 20€ TTC réinstallation et 20€ TTC transfert des données. 30€ TTC les deux." />
    </div>
  );
}

export default TarifsComposant;
